import React from 'react'
import { LaTercera } from '@labcon/copesa-logos'
import LogoRanking from '@/images/logo-ranking-2021-full.svg'
import { Link } from 'gatsby'

import Button from '@/components/Button'
import styled from 'styled-components'

const StyledHeader = styled.header`
  backdrop-filter: saturate(200%) blur(5px);
  background-color: rgba(255, 255, 255, 0.8);
  .container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`

const Header = () => (
  <StyledHeader className="fixed top-0 left-0 right-0 border-solid border-gray-300 z-20 shadow-md items-center justify-center">
    <div className="h-16 mx-auto container sm:px-4 px-2 lg:px-20">
      <div className="p-2">
        <Link to="/" className="h-10 block">
          <img
            src={LogoRanking}
            alt="Ranking de las Universidades 2021"
            className="block h-10"
          />
        </Link>
      </div>
      <div className="p-2">
        <a
          target="_blank"
          className=" justify-end flex  items-center h-10"
          href="https://www.latercera.com/?utm_source=landingbienvenida&utm_medium=web&utm_campaign=logo-latercera&utm_content=logo-latercera-header">
          <LaTercera red="black" width="200" height="20" />
        </a>
      </div>
    </div>
  </StyledHeader>
)

export default Header
